// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'

const ModalHeadLineContaner = styled.div`
  text-align: center;
`

const ModalHeadLineTitle = styled.h2`
  font-size: ${fontSize.medium_2}px;
  font-weight: bold;
  line-height: 1.3;
  ${mediaMin.phone`
    font-size: ${fontSize.large_2}px;
  `};
`

const ModalHeadLineDesc = styled.p`
  margin-top: ${spacing.small_3}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  line-height: 1.5;
  ${mediaMin.phone`
    font-size: ${fontSize.small_2}px;
  `};
`

export type PropTypes = {
  title: string,
  textList: Array<string>,
}

export default (props: PropTypes) => (
  <ModalHeadLineContaner>
    <ModalHeadLineTitle>{props.title}</ModalHeadLineTitle>
    <ModalHeadLineDesc>
      {props.textList.map((text, i) => (
        <span key={`dialogContent${i}`}>
          {text}
          {i < props.textList.length && <br />}
        </span>
      ))}
    </ModalHeadLineDesc>
  </ModalHeadLineContaner>
)



// WEBPACK FOOTER //
// ./src/components/molecules/ModalHeadline/index.jsx